/* eslint-disable */
import React from 'react';
import { BaseFilter, FacultyFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    Datagrid,
} from 'react-admin';
import { FacultyGroupLabels } from './FacultyGroup';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';

export const FacultyLabels = {
    pageTitle: 'Faculties',
    singleLabel: 'Faculty',
    canProposeCourses: 'Can propose courses',
    isAcademic: 'Is academic',
};

export const FacultyList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={FacultyLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label="Code" source="Title" />
                    <TextField source="description" />
                    <BooleanField
                        label={FacultyLabels.isAcademic}
                        source="isAcademic"
                    />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const FacultyEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" />
                    <TextInput label="Code" source="Title" />
                    <TextInput source="description" />
                    <BooleanInput
                        label={FacultyGroupLabels.isAcademic}
                        source="isAcademic"
                    />
                    <BooleanInput
                        label={FacultyLabels.canProposeCourses}
                        source="canProposeCourses"
                    />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const FacultyCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label="Code" source="Title" />
            <TextInput source="description" />
            <BooleanInput
                label={FacultyGroupLabels.isAcademic}
                source="isAcademic"
            />
            <BooleanInput
                label={FacultyLabels.canProposeCourses}
                source="canProposeCourses"
                defaultValue={false}
            />
            <BooleanInput source="current" defaultValue={false} />
        </SimpleForm>
    </Create>
);

export const FacultyShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Code" source="Title" />
            <TextField source="description" />
            <BooleanField
                label={FacultyGroupLabels.isAcademic}
                source="isAcademic"
            />
            <BooleanField
                label={FacultyLabels.canProposeCourses}
                source="canProposeCourses"
            />
            <BooleanField source="current" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
